




















import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import DatajobServices from '@/services/datajob';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import JobFilter from '../../components/data/datajob-filter.vue';
import JobList from '../../components/data/datajob-list.vue';
@Component({
  components: { JobFilter, JobList }
})
export default class Job1 extends mixins(PageMixin, DictMixin)  {
  bread = [{ name: '作业调度管理' }, { name: '数据管理作业' }];
  jobSrv = new DatajobServices();

  created() {
    this.getList();
  }

  list: any[] = [];
  async getList(params?: object) {
    this.loading = true;
    let res = await this.jobSrv.getPageList({ ...params, current: this.page, size: this.limit });
    this.list = res.data;
    this.total = res.recordsTotal;
    this.loading = false;
  }
}
